import { render } from "./TDSettingEdit.vue?vue&type=template&id=0465057a"
import script from "./TDSettingEdit.vue?vue&type=script&lang=js"
export * from "./TDSettingEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__